function DDUFooterPitLimiter({value}) {
    return (
        <div class="relative flex items-center justify-center border-[#9c9c9c] border-[2px] rounded-[10px] text-[#9c9c9c]">
            <p class={`${value["pit-limiter"] === 1 ? "bg-[#0743c2]" : "bg-[#0a0f14]"} absolute top-[-13px] text-[12px] px-3 py-1 uppercase font-bold`}>PIT</p>
            <h1 class="text-[14px] font-bold uppercase">{value["pit-limiter"] === 0 ? "Inactive" : "Active"}</h1>
        </div>
    );
}

export default DDUFooterPitLimiter;